import {
  CalendarDateTime,
  parseDateTime,
  parseZonedDateTime,
  ZonedDateTime,
} from "@internationalized/date";
import type { z } from "zod";

import type { createNew } from "@blis/shared/schemas/accession";

export type FormValues = z.infer<typeof createNew>;
export type FormInput = z.input<typeof createNew>;
export type Instruction = FormValues["instructions"][0];

export function toDateValue(value: CalendarDateTime | ZonedDateTime): string;
export function toDateValue(
  value: string | null | undefined,
): CalendarDateTime | ZonedDateTime | null;
export function toDateValue(
  value: CalendarDateTime | ZonedDateTime | string | null | undefined,
) {
  if (!value) return null;

  if (typeof value === "string") {
    try {
      return parseDateTime(value);
    } catch (e) {
      try {
        return parseZonedDateTime(value);
      } catch (e2) {
        console.warn("invalid format", e, e2);
        return null;
      }
    }
  }
  if (value instanceof CalendarDateTime) {
    return value.toString();
  }
  if (value instanceof ZonedDateTime) {
    return value.toAbsoluteString().replace("Z", "");
  }
  if (typeof value === "undefined") {
    return null;
  }
  return "";
}
